<template>
  <f7-page id="ua-verify" name="ua-verify" @page:afterin="afterin">
    <f7-navbar class="view-mobile no-border">
      <f7-nav-left class="back-button">
        <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
      </f7-nav-left>
      <f7-nav-right></f7-nav-right>
    </f7-navbar>
    <f7-block>
      <div class="fs-24 fw-bold mb-xxl">{{ $t('ua-upload-docs-title') }}</div>
      <f7-list>
        <f7-list-item v-for="doc in docList" name="doc-ekyc" :key="doc.id" @click="chooseEKYCDocument(doc)">
          <img :src="require('@/assets/img/ekyc/ic_doc_upload.svg')"/>
          <p>{{doc.name}}</p>
          <i class="f7-icons">chevron_right</i>
        </f7-list-item>
      </f7-list>
    </f7-block>
  </f7-page>
</template>

<style>
#ua-verify .list ul {
  background-color: transparent;
}
#ua-verify .list .item-content {
  margin: 12px 0;
  border-radius: 10px;
  border: 1px solid #EFEFEF;
  background-color: #FFFFFF;
  padding: 20px;
  font-size: 16px;
  font-weight: 600;
  color: #13161D;
  line-height: 20px;
}
#ua-verify .list .item-inner {
  padding: 0;
  min-height: auto;
}
#ua-verify .list .item-inner:after {
  content: none;
}
#ua-verify .list .item-inner p {
  width: calc(100% - 39px);
  margin: 0 8px;
}
</style>

<script>
  import { mapGetters, mapActions } from "vuex";

  export default {
    mounted (){
      // Required for everypage. Toggle desktop-view footer.
      this.toggleFooterVisibility(false)
      this.$f7.$('.page-content').on('scroll', (e) => {
        this.toggleFooterVisibility(e.target)
      })

    },
    data() {
      return {
        docList: [
          {id: 1, name: this.$t('ua-option-docs')},
          {id: 2, name: this.$t('ua-option-poa')}
        ],
      }
    },
    methods: {
      ...mapActions('auth', ['login']),
            
      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },
      async chooseEKYCDocument(doc) {
        if(doc.id == 1) {
          this.$f7router.navigate('/verify/type-list', { transition: 'f7-push' }); 
        } else if(doc.id == 2) {
          this.$f7router.navigate("/verify/take-photo", { props: { doc: {id: 17, name: 'POA'} }});
        }
      },
      backButton() {
        this.$f7router.back({ transition: 'f7-push' });
      }
    },
    computed: {
      ...mapGetters('auth', [
          'authenticating',
          'authenticationError',
          'authenticationErrorCode',
          'authenticationSuccess'
      ])
    }
  }
</script>